module.exports = __webpack_public_path__ + "img/7.af3deb17.jpeg";